import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Icons = {
  Dashboard: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
    </svg>
  ),
  Home: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
  Certificate: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
    </svg>
  ),
  Portfolio: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Blog: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    </svg>
  ),
  Profile: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Users: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  Media: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  Logout: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
    </svg>
  ),
};

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Decode role from JWT for conditional menu items
  const getRole = () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) return null;
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.role;
    } catch {
      return null;
    }
  };
  const role = getRole();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    navigate("/login");
  };

  const linkClass = (path) => {
    const isActive = location.pathname === path;
    return `flex items-center gap-3 px-4 py-3 text-sm font-semibold transition-all duration-200 rounded-xl group ${
      isActive
        ? "bg-blue-600 text-white shadow-lg shadow-blue-900/20"
        : "text-gray-400 hover:bg-gray-800 hover:text-blue-400"
    }`;
  };

  return (
    <div className="flex flex-col w-full md:w-64 bg-gray-950 border-r border-gray-900 md:h-screen md:sticky md:top-0 z-50 transition-colors">
      <div className="flex-shrink-0 px-6 py-8 flex items-center justify-between">
        <div className="flex flex-col">
          <span className="text-[10px] font-bold text-blue-500 uppercase tracking-[0.3em]">Cms Panel</span>
          <h1 className="text-xl font-black text-white tracking-tight italic">AFFAN HAIDAR</h1>
        </div>
        <button
          className="p-2 rounded-lg md:hidden hover:bg-gray-800 transition-colors text-gray-400"
          onClick={() => setOpen(!open)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={open ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"} />
          </svg>
        </button>
      </div>

      <nav className={`flex-grow px-4 space-y-1.5 overflow-y-auto ${open ? "block" : "hidden md:block"}`}>
        <p className="px-4 pt-4 pb-2 text-[10px] font-bold text-gray-600 uppercase tracking-widest">Main Menu</p>

        <Link className={linkClass("/admin/dashboard")} to="/admin/dashboard" onClick={() => setOpen(false)}>
          <Icons.Dashboard />
          Dashboard
        </Link>

        <Link className={linkClass("/")} to="/" onClick={() => setOpen(false)}>
          <Icons.Home />
          Main Page
        </Link>

        <p className="px-4 pt-6 pb-2 text-[10px] font-bold text-gray-600 uppercase tracking-widest">Content</p>

        <Link className={linkClass("/admin/portofolio")} to="/admin/portofolio" onClick={() => setOpen(false)}>
          <Icons.Portfolio />
          Portfolio
        </Link>

        <Link className={linkClass("/admin/certificate")} to="/admin/certificate" onClick={() => setOpen(false)}>
          <Icons.Certificate />
          Certificate
        </Link>

        <Link className={linkClass("/admin/blog")} to="/admin/blog" onClick={() => setOpen(false)}>
          <Icons.Blog />
          Blog
        </Link>

        <Link className={linkClass("/admin/comments")} to="/admin/comments" onClick={() => setOpen(false)}>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
          </svg>
          Comments
        </Link>

        <Link className={linkClass("/admin/media")} to="/admin/media" onClick={() => setOpen(false)}>
          <Icons.Media />
          Media & Images
        </Link>

        <p className="px-4 pt-6 pb-2 text-[10px] font-bold text-gray-600 uppercase tracking-widest">Profile</p>

        <Link className={linkClass("/admin/profile")} to="/admin/profile" onClick={() => setOpen(false)}>
          <Icons.Profile />
          Profile & Resume
        </Link>

        {role === "superadmin" && (
          <>
            <p className="px-4 pt-6 pb-2 text-[10px] font-bold text-gray-600 uppercase tracking-widest">Superadmin</p>
            <Link className={linkClass("/admin/users")} to="/admin/users" onClick={() => setOpen(false)}>
              <Icons.Users />
              User Management
            </Link>
          </>
        )}

        <div className="pt-10 mt-auto">
          <button
            className="flex items-center gap-3 w-full px-4 py-3 text-sm font-bold text-gray-500 hover:text-red-400 hover:bg-red-400/5 rounded-xl transition-all group"
            onClick={handleLogout}
          >
            <span className="group-hover:translate-x-1 transition-transform">
              <Icons.Logout />
            </span>
            Logout
          </button>
        </div>
      </nav>

      <div className="p-4 bg-gray-900/50 border-t border-gray-900">
        <div className="flex items-center gap-3 px-2">
          <div className="w-10 h-10 rounded-full bg-blue-600/20 border border-blue-600/30 flex items-center justify-center text-blue-500 text-xs font-bold">
            AH
          </div>
          <div className="flex flex-col overflow-hidden">
            <span className="text-sm font-bold text-gray-100 truncate uppercase tracking-tighter">Affan Haidar</span>
            <span className="text-[10px] text-green-400 font-medium flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(34,197,94,0.6)]" />
              {role === "superadmin" ? "Superadmin" : "Admin"} Online
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
